"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_TYPE = void 0;
exports.PAGE_TYPE = {
    HOME_PAGE: 'Home',
    READ_PAGE: 'Content Page',
    CATEGORY_PAGE: 'Category Page',
    SUBCATEGORY_PAGE: 'Listing Page',
    PRODUCT_PAGE: 'Product Page',
};
//# sourceMappingURL=pageType.js.map